import { BaseReportBloc } from './bloc.base';

export class CloudReportBloc extends BaseReportBloc {

}
